import React from "react";
import { Switch } from "@mui/material";
import { styled } from "@mui/system";

interface OptionSwitchProps {
  isDisabled?: boolean;
  isDefaultChecked?: boolean;
  checked?: boolean;
  isRTL?: boolean;
  value?: any;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
}

const OptionSwitch = (props: OptionSwitchProps) => {
  const {
    isDisabled,
    isDefaultChecked,
    checked,
    value,
    isRTL,
    onChange,
    name,
  } = props;

  const StyledOptionSwitch = styled(Switch)(({ theme }) => ({
    padding: 8,
    marginLeft: isRTL ? "0" : "-8px",
    "& .MuiSwitch-colorPrimary.Mui-disabled": {
      color: "var(--dmg-bg)",
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "var(--dmg-blue-accent)",
      opacity: 0.9,
    },
    "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled": {
      color: "var(--dmg-blue-accent)",
    },
    "& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "var(--dmg-blue-accent)",
      opacity: 0.2,
    },
    "& .MuiSwitch-track": {
      borderRadius: 22 / 2,
      "&:before, &:after": {
        content: '""',
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: 16,
        height: 16,
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "none",
      width: 16,
      height: 16,
      margin: 2,
    },
  }));

  return (
    <StyledOptionSwitch
      color="primary"
      disabled={isDisabled}
      defaultChecked={isDefaultChecked as boolean}
      checked={checked}
      onChange={onChange}
      value={value}
      name={name}
      style={{
        color: "var(--dmg-bg)",
        fontSize: "16px",
        fontWeight: "bold",
        marginRight: "8px",
      }}
    />
  );
};

export default OptionSwitch;
